import * as z from 'zod';

export const MimeType = {
  JPG: 'image/jpeg',
  GIF: 'image/gif',
  PNG: 'image/png',
} as const satisfies Record<string, string>;
export type MimeType = (typeof MimeType)[keyof typeof MimeType];

export const Extension = {
  JPG: 'jpg',
  GIF: 'gif',
  PNG: 'png',
} as const satisfies Record<string, string>;
export type Extension = (typeof Extension)[keyof typeof Extension];

const MimeType_Extension_MAP: Record<MimeType, Extension> = {
  [MimeType.JPG]: Extension.JPG,
  [MimeType.GIF]: Extension.GIF,
  [MimeType.PNG]: Extension.PNG,
} as const satisfies Record<MimeType, Extension>;

export const mimeTypeToExtension = (mimeType: MimeType): Extension => {
  return MimeType_Extension_MAP[mimeType];
};

export const mimeTypeSchema = z.enum([MimeType.JPG, MimeType.GIF, MimeType.PNG]);
